var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([{ backgroundColor: _vm.bColor }])},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }